(function(window, templates, BubbleView, highlightDisabler, localizationStrings) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.questionSetConfirmationView = (function() {
      var _containerId = '.start-question-set-confirmation-container';
      var _superView = BubbleView.create(_containerId);
      var _reviewControlId = '.review-button';
      var _confirmControlId = '.confirm-button';
      var _viewTemplate;

      if (templates && templates.question_set_confirmation_template) {
         _viewTemplate = templates.question_set_confirmation_template;
      } else {
         throw Error('questionSetConfirmationView: Question Set Confirmation Template not found.');
      }

      return {
         getViewMarkup: function(reviewText, confirmationText) {
            var context = {reviewText: reviewText, confirmationText: confirmationText, title: localizationStrings.strings.accessQuestionSetConfirmationTitle, alertText: localizationStrings.strings.accessVideoPausedForQuiz};
            return _viewTemplate(context) + _superView.getOverlayMarkup();
         },
         getReviewControlRef: function() {
            return _reviewControlId;
         },
         getConfirmControlRef: function() {
            return _confirmControlId;
         },
         showView: function() {
            _superView.showView(true);
            var $confirmControl = window.$(_containerId).find(_confirmControlId);
            $confirmControl.focus();
            highlightDisabler.disableHighlights($confirmControl);
         },
         removeView: _superView.removeView,
         updateViewPosition: _superView.updateViewPosition,
         setBottomOffset: _superView.setBottomOffset,
         pointAt: _superView.pointAt

      };
   }());
}(this, window.TSC.templates, window.TSC.BubbleView, window.TSC.highlightDisabler, window.TSC.localizationStrings));
